import React, { useContext } from 'react';

import { ExclamationCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { Flex, Tag, Typography } from 'antd';

import { FAQ } from './FAQ';
import { FormContent } from './FormContent';
import { PartnerStatsWarnings } from './PartnerStatsWarnings';
import { usePartnerStats } from '../../api/getPartnerStats';
import { ErrorAlertPartnerStats } from '../Errors/ErrorAlertPartnerStats';
import { ShipmentIcon } from '../Icons/ShipmentIcon';
import { PartnerData } from '@/features/lp-village/partners/api/useLPPartner';
import { CurrentPartnerContext } from '@/features/lp-village/partners/views/LPPartnerDetails';

const { Text } = Typography;

export const ClosureModal = () => {
  const {
    data: partnerStats,
    isPending,
    isError,
    refetch,
  } = usePartnerStats({});

  // TODO: Change by using react-query getPartner when rebuild
  const {
    partnerState: { data: partner },
  } = useContext<PartnerData>(CurrentPartnerContext);

  let children: React.ReactNode = null;

  if (isError) {
    children = <ErrorAlertPartnerStats refetch={refetch} />;
  }

  if (isPending) {
    children = <LoadingOutlined data-testid="loading-stats" />;
  }

  if (partnerStats) {
    children = (
      <Flex gap=".5rem" vertical align="flex-start">
        {partnerStats.cannotClosePartner && (
          <Text type="danger">
            You can start the closure procedure,
            <br />
            but you cannot close the organisation directly.
          </Text>
        )}
        <PartnerStatsWarnings />
      </Flex>
    );
  }

  return (
    <Flex
      gap="2rem"
      vertical
      align="center"
      style={{
        background: 'transparent',
      }}
    >
      {/* Icon + confirm phrase */}
      <Flex gap=".75rem" vertical align="center">
        <ExclamationCircleOutlined
          style={{
            fontSize: '3.625rem',
            color: '#C82F21',
            padding: '.4375rem',
          }}
        />

        <Text
          style={{
            fontSize: '1.125rem',
            fontWeight: '500',
            textAlign: 'center',
          }}
        >
          Are you sure you want to close this organisation ?
        </Text>
      </Flex>
      {/* Partnership Name + Content + Reason + FAQ */}
      <Flex
        gap="1.5rem"
        vertical
        align="center"
        style={{
          zIndex: 2,
          width: '100%',
        }}
      >
        {/*  Partnership Name */}
        <Flex gap=".5rem" vertical align="center">
          <Text
            style={{
              fontSize: '1.75rem',
              fontWeight: 500,
              lineHeight: '130%',
              textAlign: 'center',
            }}
          >
            {partner.partner_id_card?.client_name}
          </Text>
          {partnerStats?.inBusiness.value !== null && (
            <Tag color="#F4F6F6">
              <Flex gap=".25rem" align="center">
                <ShipmentIcon color="#1A5047" size="0.75rem" />
                <Text
                  strong
                  style={{
                    color: '#1A5047',
                    fontSize: '.75rem',
                  }}
                >
                  {partnerStats?.inBusiness.value} product
                  {partnerStats?.inBusiness.value || 0 > 1 ? 's' : ''}
                  &nbsp;held by organisation
                </Text>
              </Flex>
            </Tag>
          )}
        </Flex>
        {/*  Content */}
        {children}
        {/*  Reason block */}
        <FormContent isPending={isPending} />
        {/*  FAQ */}
        <FAQ />
      </Flex>
    </Flex>
  );
};
